import { Container } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";

export default function MainLayout({ children, isMobileView }) {
  return (
    <Container fluid className={`page-layout px-0 h-100 ${isMobileView ? "mobile-view" : ""}`}>
      <div className="main-home h-100">{children}</div>
      <ToastContainer style={{ zIndex: 1000000000000 }} />
      <Tooltip id="my-tooltip" style={{ whiteSpace: "normal", maxWidth: "500px" }} />
    </Container>
  );
}
